// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"231":"8fb24e2a9338b1e78af9","344":"e6f42f61b9ed77107d03","691":"5110eef79e7413c69bf1","774":"a47c2a56a472c94c3627"}[chunkId] + ".js";
};